
<template>
    <div>  
        <ValidationObserver ref="formValidate">
            <b-row>
                <b-col cols="4">
                    <ValidationProvider name="semester" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('semester')">
                            <semesters-selectbox v-model="form.semester_id"
                                                 disabled
                                                 :setActive="true"
                                                 :validate-error="errors[0]"></semesters-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="4">
                    <b-form-group :label="$t('course')" class="mb-1">
                        <ValidationProvider name="course_id" rules="required"
                                            v-slot="{ errors }">
                            <instructor-course-auto-complete v-model="form.course_id"
                                                             :semesterId="semesterId"
                                                             :validate-error="errors[0]"/>
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('teaching_staff')">
                        <ValidationProvider name="instructor_id" rules="required" v-slot="{ errors }">
                            <staff-auto-complete v-model="form.instructor_id"
                                                 :validate-error="errors[0]" />
                        </ValidationProvider>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="title" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('title')">
                            <b-form-input v-model="form.title"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]">
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="4">
                    <ValidationProvider name="from_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('from_date')">
                            <b-form-input type="datetime-local" v-model="form.from_date"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="4">
                    <ValidationProvider name="to_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('to_date')">
                            <b-form-input type="datetime-local" v-model="form.to_date"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="file" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('file')">
                            <div class="d-flex custom-file-upload">
                                <b-form-file v-model="form.file"
                                             :state="errors[0] ? false : (valid ? true : null)"
                                             :placeholder="$t('select_file')"
                                             :drop-placeholder="$t('drop_file')"
                                             ref="fileInput"
                                             multiple
                                />
                                <b-button variant="outline-secondary"
                                          @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}
                                </b-button>
                            </div>
                            <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12">
                    <ValidationProvider name="section_ids" rules="required" v-slot="{ errors }">
                        <b-form-group :label="$t('section_id')">
                            <lined-textarea v-model="form.section_ids" :nowrap="false" :disabled="false"
                                            :styles="{ height: '124px' }" :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
        </ValidationObserver>
        <b-button variant="primary" @click="save">{{ $t('save').toUpper() }}</b-button>
    </div>

</template>
<script>

import lmsContentService from "@/services/LmsContentService";
import moment from "moment";
import InstructorCourseAutoComplete from "@/components/interactive-fields/InstructorCourseAutoComplete.vue";
import LinedTextarea from "@/components/elements/LinedTextarea.vue";

export default {
    components: {LinedTextarea, InstructorCourseAutoComplete},
    props: {
        semesterId: {},
    },
    data() {
        return {
            form:{},
            parameter:{},
        }
    },
    methods: {
        async  save() {
            const isValid = await this.$refs.formValidate.validate();
            if (isValid){
                const formData = new FormData()
                const dueDate = moment(this.form.due_date).format('YYYY-MM-DD HH:mm:ss')
                const fromDate = moment(this.form.from_date).format('YYYY-MM-DD HH:mm:ss')

                formData.append('semester_id', this.semesterId)
                formData.append('course_id', this.form.course_id)
                formData.append('title',this.form.title)
                formData.append('instructor_id',this.form.instructor_id)
                formData.append('from_date', fromDate)
                formData.append('due_date', dueDate)

                if (this.form.file && this.form.file.length) {
                    formData.append('file', this.form.file[0])
                }

                if (this.form.section_ids) {
                    this.form.section_ids
                        .split('\n')
                        .filter(x => x.trim() !== '')
                        .map(x => parseInt(x.trim()))
                        .forEach(id => {
                            formData.append('section_ids[]', id)
                        })
                }

                lmsContentService.store(formData)
                    .then(response=>{
                        this.$toast.success(response.data.message)
                        this.$emit('addContentSuccess',true)
                    }).catch(err=>{
                    this.showErrors(err)
                })
            }

        }
    },

};
</script>
